module.exports = __webpack_public_path__ + "static/media/closeCircle.ddd7c90a.svg";